import React, { Component } from 'react';

class FacebookLogin extends Component {

    constructor(props) {
        super(props);
        this.click = this.click.bind(this);
    }

    componentDidMount() {
        let fbRoot = document.getElementById('fb-root');
        if (!window.FB) {
            if (!fbRoot) {
                fbRoot = document.createElement('div');
                fbRoot.id = 'fb-root';
                document.body.appendChild(fbRoot);

                window.fbAsyncInit = () => {
                    window.FB.init({
                        version: 'v2.8',
                        appId: '1539126669661542',
                        xfbml: true,
                        cookie: true,
                        status: true
                    });

                    if (window.location.search.includes('facebookdirect')) {
                        window.FB.getLoginStatus(false);
                    }
                };
            }
            ((doc, id) => {
                if (doc.getElementById(id)) return;
                const fbScript = doc.createElement('script');
                fbScript.id = id;
                fbScript.src = '//connect.facebook.net/en_US/all.js';
                doc.body.appendChild(fbScript);
            })(document, 'facebook-jssdk');
        }
    }

    click() {
        this.props.triggerTracking();
        if (navigator.userAgent.match('CriOS')) {
            window.location.href = `https://www.facebook.com/dialog/oauth?client_id=1539126669661542&redirect_uri=${window.location.href}&state=facebookdirect&email,public_profile`;
        } else {
            window.FB.login(
                response => {
                    const { callback } = this.props;
                    const { authResponse } = response;
                    if (authResponse) {
                        FB.api('/me?fields=email,name,picture', meResponse => {
                            callback(Object.assign(authResponse, meResponse));
                        });
                    } else {
                        callback();
                    }
                },
                { scope: 'email,public_profile' }
            );
        }
    }

    render() {
        const { text, styleClasses } = this.props;
        return (
            <button type="button" className={`${styleClasses || ''} facebook-button-class`} onClick={this.click}>{text}</button>
        );
    }
}

export default FacebookLogin;
